import styled from 'styled-components';

export const MyAppsAndSubscriptionsStyled = styled.div`
	gap: 40px;
	display: flex;
	padding: 16px 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
		margin: 0 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		margin: 0 auto;
		padding: 40px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
`;

export const MenuContainerStyled = styled.div`
	display: none;
	min-width: 282px;
	max-width: 282px;
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: block;
	}
`;

export const ButtonWithBadgeStyled = styled.div`
	width: 100%;
`;
